import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("textarea", {
  name: "",
  id: "",
  cols: "30",
  rows: "10"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("放弃")
const _hoisted_5 = ["src"]

import { ref, reactive } from "vue";
import { Plus } from "@element-plus/icons-vue";
import type { UploadFile } from "element-plus/es/components/upload/src/upload.type";
import tool from "@/utils/tool";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogImageUrl = ref("");
const dialogVisible = ref(false);
const form = reactive({
  name: "ins风",
  project: "增城科慧花园",
  vr: "http://www.company.com/vr/id=34425324235125",
  status: 1,
  type: 1,
  fg: 1,
  areaId: "",
  areaName: "",
});
const handleRemove = (file: UploadFile, fileList: UploadFile[]) => {
  console.log(file, fileList);
};
const handlePictureCardPreview = (file: UploadFile) => {
  dialogImageUrl.value = file.url!;
  dialogVisible.value = true;
};

var chinaAreaDataOptions = ref("");
tool.getChinaAreaData(function (data) {
  chinaAreaDataOptions.value = data;
});

const selectAreaEvent = (value: any) => {
  if (value.length > 0) {
    //取最后一个
    var lastValue = value[value.length - 1];
    var areaName = tool.areaCodeToText.get(lastValue);
    form.areaId = lastValue;
    if (areaName != undefined) {
      form.areaName = areaName;
    }
  }
};

const bindAreaData = (areaName: string) => {
  var areaValue = tool.areaTextToCode.get(areaName);
  if (areaValue != undefined) {
    form.areaId = areaValue;
  }
};

//更新界面绑定数据
bindAreaData('石景山区');

const saveEvent = () => {
  alert("地区值：" + form.areaId);
  alert("地区名：" + form.areaName);
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      model: _unref(form),
      ref_key: "form",
      ref: form,
      "label-width": "120px",
      inline: false,
      size: "default"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(form).name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "房屋性质" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(form).status,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).status) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "住宅",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "公寓",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "别墅",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "装修类型" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(form).type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).type) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全屋",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "儿童房",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "阁楼",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "阳台",
                  value: 4
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "风格" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(form).fg,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).fg) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "新中式",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "地中海",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "欧式古典",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "所属项目" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(form).project,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).project) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "地区" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              options: _unref(chinaAreaDataOptions),
              onChange: selectAreaEvent,
              modelValue: _unref(form).areaId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).areaId) = $event))
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", null, _toDisplayString(data.label), 1),
                (!node.isLeaf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(data.children.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["options", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "介绍" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "全景VR链接" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(form).vr,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).vr) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "图册" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              action: "https://jsonplaceholder.typicode.com/posts/",
              "list-type": "picture-card",
              "on-preview": handlePictureCardPreview,
              "on-remove": handleRemove
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Plus))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: saveEvent
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          width: "100%",
          src: dialogImageUrl.value,
          alt: ""
        }, null, 8, _hoisted_5)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})